<div class="container">
  <div class="top-bar">
    <div class="title">RESET PASSWORD</div>
    <div class="close">
      <cs-icon-button iconType="icon" icon="fi-x" size="12" color="secondary" (buttonClick)="close()"> </cs-icon-button>
    </div>
  </div>
  <div class="content">
    <form [formGroup]="form">
      <div class="input-box">
        <cs-input
          [label]="'New password'"
          [placeholder]="''"
          [hasError]="isDirty && !form.controls['password'].valid"
          [type]="passwordType"
          formControlName="password"
          [suffixIconName]="passwordType === 'password' ? 'fi-eye-off' : 'fi-eye'"
          (suffixIconClick)="onPasswordClick()"
        />
      </div>
      @if (isDirty && !form.controls['password'].valid) {
        <ul class="rules">
          <li [class.valid]="!pwdErrors.range">
            <i [class]="!pwdErrors.range ? 'fi-check' : 'fi-x'"></i>
            <span> Between 8-20 characters </span>
          </li>

          <li [class.valid]="!pwdErrors.capital">
            <i [class]="!pwdErrors.capital ? 'fi-check' : 'fi-x'"></i>
            <span> 1 capital letter </span>
          </li>
          <li [class.valid]="!pwdErrors.number">
            <i [class]="!pwdErrors.number ? 'fi-check' : 'fi-x'"></i>
            <span> 1 number </span>
          </li>
        </ul>
      }
      <div class="input-box">
        <cs-input
          [label]="'Confirm new password'"
          [placeholder]="''"
          [hasError]="false"
          [type]="confirmPasswordType"
          [hasError]="confirmPwdErrors.match"
          errorHint="Passwords do not match"
          formControlName="confirmPassword"
          [suffixIconName]="confirmPasswordType === 'password' ? 'fi-eye-off' : 'fi-eye'"
          (suffixIconClick)="onConfirmPasswordClick()"
        />
      </div>
    </form>
    <cs-button
      class="submit"
      size="large"
      label="Submit"
      [disabled]="submitDisabled"
      [loading]="loading"
      (buttonClick)="submit()"
    ></cs-button>
  </div>
</div>
